var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.666 11a1.63 1.63 0 001.63-1.63 1.614 1.614 0 00-.082-.488l2.58-2.151a1.593 1.593 0 001.992-.375l2.037.68a1.63 1.63 0 003.25-.11 1.6 1.6 0 00-.188-.743l2.678-3.125a1.625 1.625 0 10-.86-1.428c.002.158.027.315.075.465l-2.821 3.293a1.574 1.574 0 00-1.745.483l-2.037-.679a1.625 1.625 0 10-3.168.593L2.429 7.94a1.61 1.61 0 00-.763-.2 1.63 1.63 0 100 3.26z",
    fill: "url(#prisk_svg__paint0_linear_4144_2284)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prisk_svg__paint0_linear_4144_2284",
    x1: 8.994,
    y1: 0,
    x2: 8.994,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E62E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })))));
}
export default __webpack_public_path__ + "static/prisk.774b2170.svg";
export { SvgPrisk as ReactComponent };